<template>
  <el-table :data='value' class="lot-list">
    <el-table-column label="样本接收单号" prop="batchNum" min-width="81">
    </el-table-column>
    <el-table-column label="客户名称" prop="clientOrganization.name" min-width="85"></el-table-column>
    <!-- <el-table-column label="送检人" prop="senders" min-width="60">
			<template slot-scope="scope">
				{{scope.row.senders ? scope.row.senders.toString() : ''}}
			</template>
		</el-table-column> -->
    <el-table-column label="订单数" min-width="60">
      <template slot-scope="scope">
        {{scope.row.orderSize}}
      </template>
    </el-table-column>
    <el-table-column label="样本接收" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unreceived=='COMPLETED'"></i>
        <span v-else-if="scope.row.unreceived == ''"></span>
        <span v-else>{{scope.row.waitingCreate ? scope.row.unreceived.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="样本提取及质控" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unchecked=='COMPLETED'"></i>
        <span v-else-if="scope.row.unchecked == ''"></span>
        <span v-else>{{scope.row.unchecked ? scope.row.unchecked.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="样本排版" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unChipSlot=='COMPLETED'"></i>
        <span v-else-if="scope.row.unChipSlot == ''"></span>
        <span v-else>{{scope.row.unChipSlot ? scope.row.unChipSlot.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <template v-if="isShowOldTableLabels">
      <el-table-column label="扩增及质控" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.unAmplification=='COMPLETED'"></i>
          <span v-else-if="scope.row.unAmplification == ''"></span>
          <span v-else>{{scope.row.unAmplification ? scope.row.unAmplification.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="杂交" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.unHybridization=='COMPLETED'"></i>
          <span v-else-if="scope.row.unHybridization == ''"></span>
          <span v-else>{{scope.row.unHybridization ? scope.row.unHybridization.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="洗染/扫描" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.unDyeAndScan=='COMPLETED'"></i>
          <span v-else-if="scope.row.unDyeAndScan == ''"></span>
          <span v-else>{{scope.row.unDyeAndScan ? scope.row.unDyeAndScan.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
    </template>
    <template v-else-if="isShowNewTableLabels">
      <el-table-column label="文库构建" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.unIndexBuild=='COMPLETED'"></i>
          <span v-else-if="scope.row.unIndexBuild == ''"></span>
          <span v-else>{{scope.row.unIndexBuild ? scope.row.unIndexBuild.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="文库质控" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.unLibraryQualityInspect=='COMPLETED'"></i>
          <span v-else-if="scope.row.unLibraryQualityInspect == ''"></span>
          <span v-else>{{scope.row.unLibraryQualityInspect ? scope.row.unLibraryQualityInspect.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="上机测序" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.uncheckedDNA=='COMPLETED'"></i>
          <span v-else-if="scope.row.uncheckedDNA == ''"></span>
          <span v-else>{{scope.row.uncheckedDNA ? scope.row.uncheckedDNA.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
    </template>
    <el-table-column label="数据质控" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.waitingDataAnalysis=='COMPLETED'"></i>
        <span v-else-if="scope.row.waitingDataAnalysis == ''"></span>
        <span v-else>{{scope.row.waitingDataAnalysis ? scope.row.waitingDataAnalysis.split('/')[1] : ''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="已完成" min-width="72">
      <template slot-scope="scope">
        <!-- <i class="el-icon-check" v-if="scope.row.waitingDataAnalysis=='COMPLETED'"></i> -->
        <span>{{scope.row.unComplete?scope.row.unComplete:'--'}}</span>
      </template>
    </el-table-column>
    <template v-if="!isOrderBranch">
      <el-table-column label="检测实验" min-width="72" v-if="!isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.uncheckedDNA=='COMPLETED'"></i>
          <span v-else-if="scope.row.uncheckedDNA == ''"></span>
          <span v-else>{{scope.row.uncheckedDNA ? scope.row.uncheckedDNA.split('/')[1] :''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="报告生成" min-width="72" v-if="isUCAS">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row.waitingReportCreate=='COMPLETED'"></i>
          <span v-else-if="scope.row.waitingReportCreate == ''"></span>
          <span v-else>{{scope.row.waitingReportCreate ? scope.row.waitingReportCreate.split('/')[1] : ''}}</span>
        </template>
      </el-table-column>
    </template>
    <slot />
  </el-table>
</template>
<script>
/**
   * 批次内的订单视图
   */
export default {
  name: 'lots-list',
  props: {
    value: {
      type: Array,
      required: true
    },
    selectSeqType: String
  },
  computed: {
    isUCAS () {
      return this.$store.state.saasConfig.tenant === 'ucas'
    },
    routeName () {
      return this.$route.name
    },
    // 是否批次预览页面
    isOrderBranch () {
      return this.routeName === 'gene-lab-order-branch'
    },
    // 只有选择类型为芯片时，显示部分表头
    isShowOldTableLabels () {
      return this.selectSeqType === 'AFFYMETRIX'
    },
    // 选择建库的时候，展示建库相关表头
    isShowNewTableLabels () {
      return this.selectSeqType === 'ILLUMINA' || this.selectSeqType === 'OLINK'
    }
  },
  created () {
  }
}

</script>
